const app = require('app'),
    en = require('shared/i18n/en/en'),
    es = require('shared/i18n/es/es'),
    getCookie = require('shared/helpers/getCookie');
// Getting the language cookie value here, in effect, caches the language setting for the function exported by this module,
// which speeds up its performance. This helped improve wellbore grid template performance a bit, but should also provide some
// benefit for the site as a whole. This should be safe to do, because language changes always necessitate a full page reload anyway.
const lang = getCookie('language') || 'en';

// The sole responsibility of this module is to lookup translation keys and return the corresponding values.
// If no value is found for a given key, the key is returned.
module.exports = function (keys) {
    let languagePack = lang == 'es' ? es : en;
    let result;
    if (Array.isArray(keys)) {
        result = keys.map(key => languagePack[key] || key);
    }
    else {
        result = [languagePack[keys]] || key;
    }
    return result;
};
